import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { CMS_PAGE } from 'Component/Header/Header.config';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import PromotionList from './PromotionList.component';
import { history } from 'Route';

const PromotionsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Promotions/Promotions.dispatcher'
);

export const mapStateToProps = state => ({
    promotions: state.PromotionsReducer.promotions,
    isLoading: state.PromotionsReducer.isLoading
});

export const mapDispatchToProps = dispatch => ({
    getPromotions: (options) => PromotionsDispatcher.then(
        ({ default: dispatcher }) => dispatcher.handleData(dispatch, options)
    ),
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

export class PromotionListContainer extends PureComponent {
    componentDidMount() {
        const { getPromotions, toggleBreadcrumbs } = this.props;

        // Get promotions
        getPromotions();

        // Remove breadcrumbs
        toggleBreadcrumbs(false);

        // Change meta
        this.updateMeta();

        // Change header state (for mobile header)
        this.updateHeaderState();
    }

    componentDidUpdate() {
        // Change meta
        this.updateMeta();

        // Change header state (for mobile header)
        this.updateHeaderState();
    }

    updateMeta() {
        const { updateMeta } = this.props;

        updateMeta({
            title: __('Promotions'),
            canonical_url: location.href
        });
    }

    updateHeaderState() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: CMS_PAGE,
            title: __('Promotions'),
            onBackClick: () => history.goBack()
        });
    }

    render() {
        return <PromotionList { ...this.props } />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PromotionListContainer);
